let language = {
    DETAIL_ADD_ERROR: "产品支持购买数量{{minQty}}",
    DETAIL_ADD_TITLE:"加入购物车",
    DETAIL_WEBSIT_ADD_TITLE:"添加到{{appName}}购物车中",
    DETAIL_ADD_STORE_TITLE:"添加到商店",
}

export { language }